module.exports = __webpack_public_path__ + "static/media/lingolink-logo.ccc04c5f.jpg";